module.exports = __webpack_public_path__ + "img/logo.e491f68b.png";